<mat-card appearance="outlined" class="funnel" data-testid="onboarding-funnel">
    <div class="header-row">
        <div>
            <h3>Onboarding funnel</h3>
            <p class="description">How far users who registered themselves get through getting started. Invited users, and users who registered before the funnel was recorded, aren't counted.</p>
        </div>
        <mat-button-toggle-group [(ngModel)]="days" (change)="refresh()" aria-label="Users who registered in the last">
            @for (p of periods; track p.days) {
                <mat-button-toggle [value]="p.days">{{p.label}}</mat-button-toggle>
            }
        </mat-button-toggle-group>
    </div>

    @if (registered === 0) {
        <p class="empty">No one has registered in this period.</p>
    }@else {
        <table class="steps">
            <thead>
                <tr>
                    <th scope="col">Step</th>
                    <th scope="col" class="bar-col"><span class="visually-hidden">Share of registered users</span></th>
                    <th scope="col" class="number">Users</th>
                    <th scope="col" class="number" matTooltip="Share of users who reached the step before">From previous</th>
                    <th scope="col" class="number" matTooltip="Median time from registering, for the users who reached the step">Median time</th>
                </tr>
            </thead>
            <tbody>
                @for (r of rows; track r.step) {
                    <tr [class.selected]="r.step === selectedStep">
                        <th scope="row">
                            <button type="button" class="step" [matTooltip]="FUNNEL_TEXT[r.step].hint + '. Choose it to list its users'" (click)="select(r.step)"
                                [attr.aria-pressed]="r.step === selectedStep" [attr.data-testid]="'funnel-step-' + r.step">{{FUNNEL_TEXT[r.step].label}}</button>
                        </th>
                        <td class="bar-col">
                            <div class="bar-track"><div class="bar" [style.width.%]="r.ofRegistered"></div></div>
                        </td>
                        <td class="number">{{r.count}} <span class="muted">({{r.ofRegistered}}%)</span></td>
                        <td class="number">{{r.ofPrevious === undefined ? '' : r.ofPrevious + '%'}}</td>
                        <td class="number">{{formatDuration(r.medianTime)}}</td>
                    </tr>
                }
            </tbody>
        </table>

        @if (selectedStep) {
            <section class="step-users" data-testid="funnel-step-users" [attr.aria-label]="'Users at ' + FUNNEL_TEXT[selectedStep].label">
                <div class="step-users-header">
                    <h4>{{FUNNEL_TEXT[selectedStep].label}}: {{stepUsers.length}} {{stepUsers.length === 1 ? 'user' : 'users'}}</h4>
                    <mat-button-toggle-group [(ngModel)]="mode" (change)="refresh()" aria-label="Which users to list">
                        <mat-button-toggle value="reached" matTooltip="Everyone who reached this step">Reached it</mat-button-toggle>
                        <mat-button-toggle value="stopped" matTooltip="Those who reached this step and got no further">Stopped here</mat-button-toggle>
                    </mat-button-toggle-group>
                    <button mat-icon-button type="button" (click)="select(selectedStep)" aria-label="Close the list" matTooltip="Close"><mat-icon>close</mat-icon></button>
                </div>
                @if (stepUsers.length === 0) {
                    <p class="empty">{{mode === 'stopped' ? 'No one stopped at this step in this period.' : 'No one reached this step in this period.'}}</p>
                }@else {
                    <div class="step-users-scroll">
                        <table class="users">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Registered</th>
                                    <th scope="col" class="number">Reached after</th>
                                    <th scope="col">Furthest step</th>
                                    <th scope="col">Last signed in</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (u of stepUsers; track u.key) {
                                    <tr>
                                        <td>{{u.name}}</td>
                                        <td><a [href]="'mailto:' + u.email">{{u.email}}</a></td>
                                        <td>{{u.registered | date:'d MMM y'}}</td>
                                        <td class="number">{{u.timeToReach ? formatDuration(u.timeToReach) : '-'}}</td>
                                        <td>{{FUNNEL_TEXT[u.furthest].label}}</td>
                                        <td>{{u.signedIn ? (u.signedIn | date:'d MMM y') : '-'}}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </section>
        }
    }
</mat-card>
